<template>
  <div>
    <div :class="['text-[1.15rem] font-normal text-white', props.songClass]">{{ props.song }}</div>
    <div class="text-xs font-light text-gray-300">{{ props.artist }}</div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  song: {
    type: String,
    default: '-'
  },
  artist: {
    type: String,
    default: '-'
  },
  songClass: {
    type: String,
    default: ''
  }
});
</script> 